var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockCircledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#A0A0A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.75V6.88887C4.91407 6.89688 4.8282 6.90524 4.74238 6.91394C4.16068 6.97293 3.69758 7.42728 3.62751 8.00775C3.5424 8.71275 3.5 9.54867 3.5 10.5162C3.5 10.8631 3.50545 11.1709 3.51638 11.4397C3.55215 12.3193 4.23575 13.0354 5.11274 13.112C6.16619 13.204 7.12855 13.25 8 13.25C8.87116 13.25 9.83317 13.204 10.8862 13.1121C11.7621 13.0356 12.4453 12.3212 12.4825 11.4428C12.4942 11.1667 12.5 10.8498 12.5 10.4919C12.5 9.53092 12.458 8.70297 12.3737 8.00731C12.3034 7.42711 11.8404 6.97307 11.259 6.91408C11.1727 6.90532 11.0864 6.89692 11 6.88887V5.75C11 4.09315 9.65685 2.75 8 2.75C6.34315 2.75 5 4.09315 5 5.75ZM7.40016 10.0502C7.46303 10.0974 7.50002 10.1715 7.50002 10.2501V11.25C7.50002 11.5261 7.72388 11.75 8.00002 11.75C8.27616 11.75 8.50002 11.5261 8.50002 11.25V10.2501C8.50002 10.1715 8.53701 10.0974 8.59988 10.0502C8.85012 9.86224 9.00002 9.56881 9.00002 9.25C9.00002 8.69772 8.5523 8.25 8.00002 8.25C7.44774 8.25 7.00002 8.69772 7.00002 9.25C7.00002 9.56881 7.14992 9.86224 7.40016 10.0502ZM7.00002 5.75V6.76529C7.3326 6.75509 7.66593 6.75 8.00002 6.75C8.33411 6.75 8.66744 6.75509 9.00002 6.76529V5.75C9.00002 5.19771 8.5523 4.75 8.00002 4.75C7.44774 4.75 7.00002 5.19771 7.00002 5.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircledIcon);
export default __webpack_public_path__ + "static/media/lock_circled_icon.0322cc1c130b132c85d2c4bb3ad4556a.svg";
export { ForwardRef as ReactComponent };